<form clrStepper [formGroup]="offerForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Kunde</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content>

      <clr-input-container>
        <label>Betreff</label>
        <input clrInput name="name_project" formControlName="name_project" />
        <clr-control-error *clrIfError="'required'">Ein Betreff muss angegeben werden</clr-control-error>
        <clr-control-error *clrIfError="'maxLength'; error as err">Betreff zu lang (max. {{ err.name_projectLenght}} Zeichen)</clr-control-error>
      </clr-input-container>

      <clr-input-container>
        <label>Beschreibung</label>
        <input clrInput name="description" formControlName="description" />
      </clr-input-container>
      <clr-input-container>
        <label>Anfragenummer des Kunden</label>
        <input clrInput name="request_id" formControlName="request_id" />
      </clr-input-container>
      <clr-input-container>
        <label>Firma (Kunde)</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="postcode" />
      </clr-input-container>
      <app-country-select controlName="country" label="Land" />
      <clr-select-container *ngIf="isUpdateMode">
        <label>Status</label>
        <select clrSelect formControlName="status" required>
          <option value="open" selected>Entwurf</option>
          <option value="sent">Abgeschickt</option>
          <option value="rejected">Entgangen</option>
          <option value="confirmed">Akzeptiert</option>
        </select>
        <clr-control-error>Statusupdate nicht vergessen!</clr-control-error>
      </clr-select-container>
      <clr-input-container *ngIf="offerStatus === 'confirmed'">
        <label>Bestellnummer des Kunden</label>
        <input clrInput name="order_id" formControlName="order_id" />
      </clr-input-container>
      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ offersData?.offer_date | date: 'dd.MM.yyyy' }}" formControlName="offer_date" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" (click)="deleteOffer()">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/offer/details', projectId, offerId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <div *ngIf="devMode">Projektleader {{ projectStaff() }}</div>

          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label *ngIf="employee.staff_id !== projectStaff()">{{ employee.firstname }} {{ employee.lastname }}</label>
          <label *ngIf="employee.staff_id === projectStaff()" class="leader"><b>{{ employee.firstname }} {{ employee.lastname }}</b></label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/offer/details', projectId, offerId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Kunden - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <select clrSelect formControlName="employee_leader">
        <option></option>
        <option *ngFor="let person of persons" [ngValue]="person.pid">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIV">
    <clr-step-title>Bedingungen</clr-step-title>
    <clr-step-description>(seitens PPS - erscheint auf dem Briefbogen)</clr-step-description>
    <clr-step-content>
      <label>Angebotsbedingungen: </label>
      <select clrSelect formControlName="cond_offer">
        <option></option>
        <option *ngFor="let condI of offer_conditions" [ngValue]="condI.cond_id">{{ condI.name }}</option>
      </select>
      <br />
      <label>Lieferbedingungen: </label>
      <select clrSelect formControlName="cond_delivery">
        <option></option>
        <option *ngFor="let condII of delivery_conditions" [ngValue]="condII.cond_id">{{ condII.name }} ({{ condII.text }})</option>
      </select>
      <br />
      <label>Zahlungsbedingungen: </label>
      <select clrSelect formControlName="cond_payment">
        <option></option>
        <option *ngFor="let condIII of payment_conditions" [ngValue]="condIII.cond_id">{{ condIII.name }}</option>
      </select>
      <br />
      <clr-input-container>
        <label>Lieferzeit:</label>
        <input clrInput formControlName="delivery_remarks" value="offersData?.delivery_remarks ?? offersData?.delivery_remarks"/>
      </clr-input-container>
      <br />
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" [disabled]="offerForm.invalid" (click)="updateOffer()">{{ isUpdateMode ? 'Aktualisieren' : 'Speichern' }}</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" (click)="deleteOffer()">abbrechen</button>
        <button class="btn" *ngIf="isUpdateMode"  [routerLink]="['/offer/details', projectId, offerId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode" class="datepicker-output">
  {{ isOfferValid }} {{ offerForm.invalid }}
  {{ offerForm.value.stepIV.cond_offer }}
  {{ projectLeader() }}
  <p>OffersForm:</p>
    {{ offerForm.value | json }}
  <p>OffersData:</p>
    {{ offersData | json }}
  <p>Staff:</p>
    {{ staff | json }}
</pre>
